import React from 'react';

export const AdditionalIncomeHintContents = () => (
  <p data-testid="income-hint">
    You may include income from other members of your household
  </p>
);
